var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetachedCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#009de0;}.a,.c{stroke:#009de0;}.b,.c{fill:#fff;}.b{stroke:#fff;}.c{stroke-width:0.5px;}.d{stroke:none;}.e{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 8,
    cy: 8,
    r: 7.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(7 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 5,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 6,
    rx: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(4 5.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 5,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: -0.25,
    y: -0.25,
    width: 5.5,
    height: 7.5,
    rx: 1.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetachedCopy);
export default __webpack_public_path__ + "static/media/detachedCopy.ce5b7a23b3e228c40c6769c18e6ff451.svg";
export { ForwardRef as ReactComponent };